import React from 'react';
import TextField from '@mui/material/TextField';
import { DateInputStyles } from './StyleOverrides';
import './EliasInput.scss';
import {
  EliasInputProps,
  handleInputChange,
  handleInputFocus,
} from './elias-input-utils';

function EliasTextInput({
  value,
  onChange,
  id,
  ariaLabel,
  isInputValid,
  focusedOption = '',
  isEditing = true,
  placeholder = undefined,
}: EliasInputProps) {
  const handleRef = (input: any) => {
    if (input !== null) {
      if (isEditing && focusedOption === id) {
        input.focus();
      } else if (!isEditing) {
        input.blur();
      }
    }
  };

  return (
    <TextField
      inputRef={handleRef}
      onFocus={handleInputFocus}
      inputProps={{
        'aria-label': ariaLabel,
        'data-testid': `${id}-value-input`,
      }}
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={(event) => handleInputChange(event, onChange)}
      sx={DateInputStyles}
      error={isInputValid === undefined ? false : !isInputValid}
    />
  );
}

export default EliasTextInput;
